export type SoSimpleTableHeaders = Array<string>
export type SoSimpleTableRow = Array<SoSimpleTableRowItem>

export type SoSimpleTableRowItem =
  SoSimpleTableRowLink | string | number | boolean

export type SoSimpleTableRowLink = {
  type?: SoSimpleTableRowType
  text: string
  href?: string
}

export enum SoSimpleTableRowType {
  LINK = "LINK",
}
